
import withAuth from "./../../common/helper/auth-component.js";
import { connect } from "react-redux";
import {
  RowsPerPageSelector,
  SearchTable,
  DataTable,
  customDataTableStyles,
} from "./../../common/helper/table-imports.js";
import React, { useState, useEffect, useCallback, useMemo } from "react";
import DashboardService from "../../../services/dashboard-service.js";
import { MESSAGES } from "../../constants/constants.js";
import LoaderOverlay from "./../../common/helper/loader.component.js";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { useSelector, useDispatch } from "react-redux";
import StatusBadge from "../../common/helper/transaction-status.component.js";
import RestartAltTwoToneIcon from "@mui/icons-material/RestartAltTwoTone";
import {
  transactionSerachFormData,
  initialErrors,
  fieldValidation,
  scrapperFormData,
} from "../../common/helper/form-constants.js";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import { useLocation } from "react-router-dom";
import Stats from "../../common/modals/stats.component.js";
import MUIButton from "../../common/miui-component/mui-button.jsx";
import FilterListIcon from "@mui/icons-material/FilterList";
import CloseIcon from "@mui/icons-material/Close";
import { DistributorList } from "../distributors/index.js";
import { paymentMethods, paymentType, transactionStatus, transactionType } from "../../common/helper/status-constant.js";
import useIsMobile from "../../common/hooks/useIsMobile.js";
import { Scrapper_data } from "../../../constants/dummyData.js";
import ScrapperFilter from "../../common/helper/scrapper-filter.js";

const ScarpperComponent = () => {
  const [errors, setErrors] = useState({ ...initialErrors });
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const dispatch = useDispatch();
  const [role, setUserRole] = useState("");
//   const [status, setStatus] = useState("");
//   const [modalShow, setModalShow] = React.useState(false);
  const [isOpenDrawer, setIsOpenDrawer] = React.useState(false);
//   const [toggleFilter, setToggleFilter] = useState("agent");
  const [loading, setLoading] = useState(false);
  const [transaction, setTransactionData] = useState();
  const [dataTableKey, setDataTableKey] = useState(0);
  const navigate = useNavigate();
  const userData = useSelector((state) => state.authReducer);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [pageNo, setPageNo] = useState(0);
  const [totalRows, setTotalRows] = useState("");
//   const [transactionStatsData, setTransactionStats] = useState([]);
//   const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [formData, setFormData] = useState({ ...scrapperFormData });
  const [filterFormData, filterSetFormData] = useState({ ...scrapperFormData });
//   const [advanceFilters, setAdvanceFilters] = useState([]);
  const [agents, setAgents] = useState([]);
  const [merchants, setMerchants] = useState([]);
  const [distributors, setDistributors] = useState([]);
  const isMobile = useIsMobile();
  const [filterApplied,setFilterApplied] = useState(true)
  const paginationComponentOptions = {
    noRowsPerPage: true,
  };
//   const [filterData, setFilterData] = useState({
//     end_date: "",
//     start_date: "",
//     merchantID: "",
//     agentID: "",
//     paymentType: "",
//     status: "",
//   });
  console.log(formData, "formData");
  const [columns, setColumns] = useState([
    {
      name: "Transaction Id",
      cell: (row) => (
        <div className="custom-cell-order_Code d-flex align-items-center">
          <p className="me-2 h-100 mb-0">{row.transaction_id}</p>

          <a
            href="javascript:void(0)"
            // onClick={() => viewTransaction(row.transaction_id)}
          >
            <OpenInNewOutlinedIcon sx={{ fontSize: "16px" }} />
          </a>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Scrapper Source",
      selector: (row) => (
        <>
          <div
          >
           
                  {row.scrapper_source}
          </div>
        </>
      ),
      sortable: true,
    },
    {
      name: "Distributor",
      selector: (row) => (
        <div className="custom-cell-order_Code">{row.distributor_name}</div>
      ),
      sortable: true,
    },
    {
      name: "Agent",
      selector: (row) => (
        row.agent_name
      ),

      sortable: true,
    },
    {
      name: "Process flag",
      selector: (row) => row.process_flag,
      sortable: true,
    },
    {
      name: "Payment Method",
      selector: (row) => (
        <>
      
          {row.user_payment_method_id || "-"}
        </>
      ),

      sortable: true,
    },
    {
      name: "Retry count",
      selector: (row) => (
        <>
          <div>
          {row?.retry_count}
          </div>
        </>
      ),
    },
  ]);

//   const viewTransaction = (id) => {
//     navigate(`/transaction/${id}?type=searchTransaction`);
//   };

//   const transactionStats = () => {
//     let transaction = DashboardService.getTransactionStats(formData);
//     setLoading(true);
//     transaction
//       .then((response) => {
//         console.log(response.data);
//         setTransactionStats(response.data.data);
//         setLoading(false);
//       })
//       .catch((error) => {
//         setLoading(false);
//         try {
//           const errorMessage = error.response.data;
//           toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
//         } catch (e) {
//           console.log(e);
//           toast.error(MESSAGES.SERVER_ERROR);
//         }
//       });
//   };

  const listTransactions = (
    pageNumber,
    rowsPage,
    transactionData = null,
    formData
  ) => {
    DashboardService.setSearchTransaction(
      transactionData ? transactionData : formData,
      pageNumber
    );

    let userRole = "";
    let transaction = DashboardService.getSystemTransaction(
      transactionData ? transactionData : formData,
      pageNumber,
      rowsPage
    );
    if (userData.user.data) {
      userRole = userData.user.data.role;
    }

    setLoading(true);

    transaction
      .then((response) => {
        console.log(response);
        const records = response.data.data.list;

        setTotalRows(response.data.data.total_records);

        setTransactionData(records);
        setLoading(false);
        setFilterApplied(true)
      })
      .catch((error) => {
        setLoading(false);
        try {
          const errorMessage = error.response.data;
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
        } catch (e) {
          toast.error(MESSAGES.SERVER_ERROR);
        }
      });
  };


  useEffect(() => {
    let userRole;
    if (userData && userData.user && userData.user.data) {
      userRole = userData.user.data.role.role_code;
      console.log(userRole);
      setUserRole(userRole);
    }


    document.body.style.backgroundImage = "";

    document.body.style.backgroundColor = "#f0f6fa";
    const typeValue = queryParams.get("type");
    let searchTransactionData = DashboardService.getSearchTransaction();
    if (typeValue == "searchTransaction") {
      setFormData(searchTransactionData);
      listTransactions(searchTransactionData.pageNo, 25, searchTransactionData);
    } else {
      listTransactions(0, 25, { ...searchTransactionData });
    }
    return () => {
      document.body.style.backgroundColor = ""; // Reset body color when ComponentOne unmounts
    };
  }, []);

  const handleRowsPerPageChange = (value) => {
    let rowsPage = Number(value);
    setRowsPerPage(rowsPage);
    setDataTableKey((prevKey) => prevKey + 1);
    listTransactions(pageNo, rowsPage, null, formData);
  };

  const handlePageChange = (page) => {
    let pageNumber = page - 1;
    setPageNo(pageNumber);
    listTransactions(pageNumber, rowsPerPage, null, formData);
  };

  const validateField = (fieldName, value) => {
    const errorMessage = fieldValidation(fieldName, value);
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
    return errorMessage;
  };

  const fetchTransaction = (formData) => {
    // setFormData(formData);
    // if (formData.from_date && formData.to_date) {
    //   if (new Date(formData.from_date) > new Date(formData.to_date)) {
    //     toast.error("From Date should not be greater than to Date");
    //     return;
    //   }
    // }
    // let hasErrors = false;
    // let requiredFields = [
    //   "merchant_order_code",
    //   "agent_email",
    //   "agent_mobile",
    //   "agent_code",
    // ];
    // requiredFields.forEach((fieldName) => {
    //   const error = validateField(fieldName, formData[fieldName]);
    //   if (error) {
    //     hasErrors = true;
    //   }
    // });
    // if (!hasErrors) {
    //   listTransactions(0, 25, null, formData);
    //   setIsOpenDrawer(false);
    // }
  };

  const downloadTransaction = () => {
    // if (new Date(formData.from_date) > new Date(formData.to_date)) {
    //   toast.error("From Date should not be greater than to Date");
    //   return;
    // }
    let hasErrors = false;
    // let requiredFields = [
    //   "merchant_order_code",
    //   "agent_email",
    //   "agent_mobile",
    //   "agent_code",
    // ];
    // requiredFields.forEach((fieldName) => {
    //   const error = validateField(fieldName, formData[fieldName]);
    //   if (error) {
    //     hasErrors = true;
    //   }
    // });
    // if (!hasErrors) {
    //   let userRole = "";
    //   let transaction = DashboardService.downloadTransactionCSV(formData);
    //   setLoading(true);
    //   transaction
    //     .then((response) => {
    //       const blob = new Blob([response.data], { type: "text/csv" });
    //       const url = window.URL.createObjectURL(blob);
    //       const link = document.createElement("a");
    //       link.href = url;
    //       link.setAttribute("download", "transactions.csv"); // Specify the file name here
    //       document.body.appendChild(link);
    //       link.click();
    //       window.URL.revokeObjectURL(url);
    //       link.parentNode.removeChild(link);
    //       toast.success("Transactions downloaded successfully.");
    //       setLoading(false);
    //     })
    //     .catch((error) => {
    //       setLoading(false);
    //       try {
    //         const errorMessage = error.response.data;
    //         toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
    //       } catch (e) {
    //         toast.error(MESSAGES.SERVER_ERROR);
    //       }
    //     });
    // }
  };

  useEffect(() => {
    if (Scrapper_data?.data.length) {
      const element = document.getElementsByClassName("sc-bHCmUC");
      const childElement = element[0].children;
      for (let i = 0; i < childElement?.length; i++) {
        const ele = childElement[i].id.split("-")[1];
        if (Number(ele) % 2 === 0) {
          childElement[i].classList.add("odd-transaction-table");
        } else {
          childElement[i].classList.add("even-transaction-table");
        }
      }
    }
  }, [Scrapper_data]);

  const handleRemoveAppliedFilter = (fieldName) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: null,
    }));
    filterSetFormData((prev) => ({
      ...prev,
      [fieldName]: null,
    }))
    fetchTransaction({ ...formData, [fieldName]: null });
  };
  console.log(paymentMethods, agents, merchants, distributors, "distributors");
  const selectedFilter = useMemo(() => {
    return Object.entries(formData).map((item) => {
      let keyName = item[0]
        .split("_")
        .map((item) => item.slice(0, 1).toLocaleUpperCase() + item.slice(1))
        .join(" ");
      let dataValues = item[1];
      if (keyName === "Distributor Id") {
        let distributorName = distributors.filter(
          (item) => item.value == dataValues
        );
        dataValues = distributorName.length
          ? distributorName[0].name
          : dataValues;
      } else if (keyName == "Customer Id") {
        let merchantName = merchants.filter((item) => item.value == dataValues);
        dataValues = merchantName.length ? merchantName[0].name : dataValues;
      } else if (keyName == "Agent Id") {
      console.log(keyName,dataValues,agents)

        let agentName = agents.filter((item) => item.value == dataValues);
        dataValues = agentName.length ? agentName[0].name : dataValues;
      } else if (keyName == "Payment Method") {
        let paymentName = paymentMethods.filter(
          (item) => item.value == dataValues
        );
        dataValues = paymentName.length ? paymentName[0].label : dataValues;
      }
      else if (keyName == "Status") {
        let transactionName = transactionStatus.filter(
          (item) => item.value == dataValues
        );
        dataValues = transactionName.length ? transactionName[0].label : dataValues;
      }
      else if (keyName == "Transaction Type") {
        let transactionName = transactionType.filter(
          (item) => item.value == dataValues
        );
        dataValues = transactionName.length ? transactionName[0].label : dataValues;
      }

      if (dataValues)
        return (
          <div
            className={`${
              isMobile ? "d-inline-block" : "d-flex "
            } px-3 py-1 mx-2 my-2`}
            style={{
              border: "2px solid rgb(145 202 207 / 77%)",
              borderRadius: "50px",
              color: "#495a69",
            }}
          >
            <span style={{ fontWeight: 700, fontSize: "14px" }}>
              {keyName.replace(/Id/i, "").trim()}
            </span>{" "}
            : <span style={{ fontSize: "14px" }}>{ dataValues}</span>{" "}
            <span
              className="ms-2"
              style={{ cursor: "pointer" }}
              onClick={() => handleRemoveAppliedFilter(item[0])}
            >
              <CloseIcon sx={{ fontSize: "17px" }} />
            </span>
          </div>
        );
    });
  }, [formData,agents,merchants,distributors]);

  const refreshTransactions = () => {
    // listTransactions(pageNo, rowsPerPage, null, formData);
  };

  return (
    <>
      <LoaderOverlay loading={loading} />
      <div className="container-fluid px-4" style={{ paddingBottom: "30px" }}>
        <div className="d-flex justify-content-between mb-3">
          <h4
            className="mb-0 updatename updatename1 align-self-center text-color-theme"
            style={{ marginTop: 0, fontWeight: 700, fontSize: "22px" }}
          >
            Scrapper List
          </h4>
          <div>
            <div>
              <MUIButton
                btnOnClick={() => setIsOpenDrawer(true)}
                btnLabel="Filter"
                btnStyle={{
                  backgroundColor: "#ffffff",
                  color: "black",
                  borderRadius: "10px",
                  "&:hover": {
                    backgroundColor: "rgb(117 121 124 / 82%)",
                  },
                }}
              >
                <FilterListIcon sx={{ fontSize: "25px", marginLeft: "6px" }} />{" "}
              </MUIButton>
            </div>
          </div>
        </div>
        <div
          className="container-fluid mb-4"
          style={{
            backgroundColor: "white",
            float: "left",
            borderRadius: "15px",
          }}
        >
          <nav className="flex justify-content-between">
            <div
              className="nav nav-tabs d-flex justify-content-between"
              id="nav-tab"
              role="tablist"
            >
              {/* <MUITextField /> */}
              <button
                className="nav-link tbbtn active text-color-theme"
                id="nav-home-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-home"
                type="button"
                role="tab"
                aria-controls="nav-home"
                aria-selected="true"
                style={{ fontSize: "16px" }}
              >
                Scrapper
              </button>
              <RestartAltTwoToneIcon
                sx={{
                  color: " #495A69",
                  fontSize: "28px",
                  marginTop: "10px",
                  cursor: "pointer",
                }}
                fontSize="small"
                onClick={refreshTransactions}
              ></RestartAltTwoToneIcon>
            </div>
            <div className="d-flex mt-3" style={{ float: "right" }}>
              <div
                className="me-3"
                onClick={() => downloadTransaction("fetchTransaction")}
              >
                <DownloadForOfflineIcon sx={{ fontSize: "35px" }} />
              </div>
            </div>
          </nav>
          <div className="flex justify-content-between align-items-center">
            <RowsPerPageSelector
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleRowsPerPageChange}
            />

            <div className="d-flex gap-3"></div>
          </div>

          <div
            className="tab-content"
            id="nav-tabContent"
            style={{ paddingTop: "15px", paddingBottom: "15px" }}
          >
            <div
              className="tab-pane fade active show"
              id="nav-home"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <div
                style={isMobile ? { overflow: "scroll", width: "340px" } : {}}
              >
                <div
                  style={
                    isMobile
                      ? {
                          display: "flex",
                          height: "50px",
                          overflow: "scroll",
                          width: "max-content",
                        }
                      : { display: "flex", flexWrap: "wrap" }
                  }
                >
                  {filterApplied && selectedFilter}
                </div>
              </div>
              <main>
                <div className style={{ paddingBottom: "30px" }}>
                  <div className style={{ backgroundColor: "white" }}>
                    <div className="tab-content" id="nav-tabContent" style={{}}>
                      <div
                        className="tab-pane fade show active"
                        id="nav-home"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab"
                      >
                        <div
                          className="col-md-12"
                          style={{ textAlign: "right" }}
                        ></div>

                        <div
                          id="examplemgmwallet_wrapper"
                          className="dataTables_wrapper dt-jqueryui no-footer"
                        >
                          <div
                            style={{
                              height: isOpenDrawer ? "425px" : "auto",
                              overflowY: isOpenDrawer ? "auto" : "visible",
                            }}
                            className="scrapper-table"
                          >
                            <DataTable
                              key={dataTableKey}
                              columns={columns}
                              data={Scrapper_data.data}
                              pagination
                              paginationComponentOptions={
                                paginationComponentOptions
                              }
                              paginationPerPage={rowsPerPage}
                              paginationServer
                              paginationTotalRows={totalRows}
                              onChangePage={handlePageChange}
                              customStyles={customDataTableStyles}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </main>
            </div>
          </div>
        </div>
        <div></div>
        <ScrapperFilter
          isOpenDrawer={isOpenDrawer}
          setIsOpenDrawer={setIsOpenDrawer}
          formData={filterFormData}
          setFormData={filterSetFormData}
          fetchTransaction={(formData) => fetchTransaction(formData)}
          module="Scrapper"
          {...{
            setAgentsData:setAgents,
            setMerchantsData:setMerchants,
            setDistributorsData:setDistributors,
          }}
        />

      </div>
    </>
  );
};

function mapStateToProps(state) {
  const userData = state.authReducer.user;
  return { userData };
}
export default withAuth(connect(mapStateToProps)(ScarpperComponent));
